var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[(_vm.iconName)?_c('img',{staticClass:"level-icon",attrs:{"src":require('@/assets/icons/' + _vm.iconName + '.svg'),"alt":_vm.iconName}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }